// extracted by mini-css-extract-plugin
export var lg = "_1b-4";
export var md = "_1b-3";
export var sm = "_1b-2";
export var xs = "_1b-1";
export var xxs = "_1b-0";